export const width=1920;export const height=642.3272727272727;export default{width:width,height:height};